// Page scroll lock shared by the popup and the detail dialog, which can be open at the same
// time (detail over popup): a counter, so closing the top one does not unlock the page while
// the other is still open. The previous inline value is restored, not blanked, because the
// host page may set its own (the pricing page's modal sets body overflow too).

let locks = 0;
let previous = '';

export function lockScroll() {
  if (locks === 0) {
    previous = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
  }
  locks++;
}

export function unlockScroll() {
  if (locks === 0) return;
  locks--;
  if (locks === 0) document.documentElement.style.overflow = previous;
}
